// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1KuCk","list":"styles_list__24S1y"};